import { Exception } from '@labradorsports/utils';

import ErrorDetails from '../error-details/error-details.js';

interface Props {
    error: Exception;
}

const CrashPage: FC<Props> = ({ error }) => {
    return (
        <div className="crash-page full-center">
            <ErrorDetails error={error} />
        </div>
    );
};

export default CrashPage;
